/* Decorative only: never cancel pointer, keyboard, scroll or navigation events. */
(() => {
 'use strict';
 const reduced=matchMedia('(prefers-reduced-motion: reduce)');
 const hover=matchMedia('(hover: hover)');
 const selector='button,a[href],summary,[role="button"],input:not([type="hidden"]),select,textarea,label[for]';
 const last=new WeakMap(),active=new Map();
 let frame=0;
 function target(event){
  const path=event.composedPath?.()||[event.target];
  return path.find(el=>el instanceof Element&&el.matches(selector))||null;
 }
 function allowed(el){
  return el&&!el.closest('.skip-to-content-link,[inert],[aria-hidden="true"]')&&!el.matches(':disabled,[aria-disabled="true"],input[type="hidden"]');
 }
 function remove(el){const item=active.get(el);if(item){item.layer.remove();active.delete(el);}}
 function tick(now){
  frame=0;
  for(const [el,item] of active){
   if(reduced.matches||document.hidden||!el.isConnected||now-item.start>1150){remove(el);continue;}
   const r=el.getBoundingClientRect();
   if(!r.width||!r.height||r.bottom<0||r.top>innerHeight){remove(el);continue;}
   const s=item.layer.style;
   s.left=r.left+'px';s.top=r.top+'px';s.width=r.width+'px';s.height=r.height+'px';
  }
  if(active.size)frame=requestAnimationFrame(tick);
 }
 function shine(el){
  if(reduced.matches||!allowed(el))return;
  const now=performance.now();
  if(now-(last.get(el)??-2000)<1300)return;
  const r=el.getBoundingClientRect();if(r.width<1||r.height<1)return;
  last.set(el,now);
  // Existing catalog buttons already have their own matching sheen layer.
  if(el.matches('.gx-card-action'))return;
  const layer=document.createElement('span');layer.className='gx-interaction-sheen';
  layer.setAttribute('aria-hidden','true');
  const cs=getComputedStyle(el);layer.style.borderRadius=cs.borderRadius;
  layer.style.left=r.left+'px';layer.style.top=r.top+'px';layer.style.width=r.width+'px';layer.style.height=r.height+'px';
  // A dialog is in the browser top layer; keep its decoration inside that layer.
  const dialog=el.closest('dialog[open]');(dialog||document.body).append(layer);
  active.set(el,{layer,start:now});if(!frame)frame=requestAnimationFrame(tick);
 }
 document.addEventListener('pointerover',event=>{
  if(event.pointerType==='touch'||!hover.matches)return;
  const el=target(event);if(el&&event.relatedTarget instanceof Node&&el.contains(event.relatedTarget))return;
  shine(el);
 },{passive:true});
 document.addEventListener('focusin',event=>{const el=target(event);if(el?.matches(':focus-visible'))shine(el);},{passive:true});
 document.addEventListener('pointerdown',event=>{
  const el=target(event);
  // Whole product-card touch continues to use the original mobile controller.
  if(['touch','pen'].includes(event.pointerType)&&event.target.closest?.('[data-gx-card]'))return;
  shine(el);
 },{passive:true});
 function clear(){for(const el of active.keys())remove(el);if(frame)cancelAnimationFrame(frame);frame=0;}
 reduced.addEventListener('change',()=>{if(reduced.matches)clear();});
 document.addEventListener('visibilitychange',()=>{if(document.hidden)clear();});
 window.addEventListener('pagehide',clear);
})();
